// extracted by mini-css-extract-plugin
export default {"root":"ContactArtist_root__EzYsA","aspectRatioWrapper":"ContactArtist_aspectRatioWrapper__wyC2m","contactBtn":"ContactArtist_contactBtn__xcM75","desc":"ContactArtist_desc__Las4d"};